
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($, _c, undefined) {
	'use strict';

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.

	var Sage = {
		// All pages
		'common': {
			init: function() {
				(function() {
					$('.swiper').each(function() {
						var ele         = $(this),
							container   = ele.find('.swiper-container').first(),
							pagnination = ele.find('.swiper-pagination'),
							nextButton  = ele.find('.swiper-button-next'),
							prevButton  = ele.find('.swiper-button-prev');

						container.swiper({
							autoplay            : 2500,
							slidesPerView       : 1,
							loop                : true,
							speed               : 1200,
							lazyLoading         : true,
							preloadImages       : false,
							resizeFix           : true,
							autoResize          : true,
							resizeReInit        : true,
							simulateTouch       : false,
							pagination          : pagnination,
							paginationClickable : true,
							nextButton          : nextButton,
							prevButton          : prevButton,
						});
					});
				})();

				$('.hamburger').on('click', function() {
					$(this).toggleClass('is-active');
					$('header .topnav').toggleClass('menu-open');
				});

				$('dl.accordion dt').on('click', function() {
					var $next = $(this).next('dd');
					$next.siblings('dd').slideUp();
					$(this).toggleClass('open');
					$next.slideToggle();
				});

				$('form input[type="file"]').each(function() {
		          var upload = $(this);
		          var labelText = $(this).parents('.gfield').find('label').text();
		          upload.wrap("<span class='upload-hide'></span>");
		          var styledUpload = "<span class='styled-upload' data-value='"+upload.val().split('\\').pop()+"' data-name='"+upload.attr('name')+"'><span class='file'>"+labelText+"</span><span class='upload primary'>Select File</span></span>";
		          upload.parent('.upload-hide').after(styledUpload);
		        });

		        $('.styled-upload .upload').on('click touchend', function () {
		          var upload = $('input[type="file"][name="'+$(this).parent().attr('data-name')+'"]');
		          upload.click();
		        });

		        $('form input[type="file"]').on('change', function () {
		          var upload = $(this);
		          var file = upload.val().split('\\').pop();
		          if (file !== "") {
		            upload.parent().next('.styled-upload').find('.file').addClass('show').text(file);
		            upload.parent().next('.styled-upload').find('.file span').dotdotdot();
		          } else {
		            upload.parent().next('.styled-upload').find('.file').find('span').text("");
		          }
		        });

		        $('.styled-upload .file').on('click touchend', function() {
		        	console.log('click event');
			        var upload = $('input[type="file"][name="'+$(this).parent().attr('data-name')+'"]');
			        if (upload.val() === "") {
			        	console.log('upload is clear');
			          	upload.click();
			        } else {
			        	console.log('upload not clear');
				        upload.val("");
				        $(this).removeClass('show');
				        upload.change();
				    }
		        });

				$('form .conditional').each(function () {
		        	var active = $(this).find('label.active').attr('for');
		        	$(this).find('.fields').find('.' + active).show().siblings().hide();
		        });

		        $('form .conditional label').on('click', function() {
		        	$(this).addClass('active').siblings('label').removeClass('active');
		        	var field = $(this).attr('for');
		        	$('.' + field).show().siblings().hide();
		        });

            var mySwiper = new Swiper('.testimonials-container', {
				    speed: 300,
				    autoHeight: true,
				    autoplay: 5000,
				    loop: true,
				    preventClicks: false,
				    nextButton: '.swiper-button-next',
				    prevButton: '.swiper-button-prev'
				});

				$('.lead h1 a').lettering('words');
				$('.lead.standard h1').lettering('words');

				$('.filter nav a').on('click', function(e) {
					e.preventDefault();
					$(this).addClass('current');
					$(this).parent().siblings().find('a').removeClass('current');
					var className = $(this).attr('href').replace("#", "");
					if ($(this).attr('href') === "#all") {
						$('.article dl.resources dt, .article dl.resources dd').fadeIn();
					} else {
						$('.article dl.resources dt').each(function() {
							if ($(this).hasClass(className)) {
								$(this).fadeIn();
								$(this).next('dd').fadeIn();
							} else {
								$(this).fadeOut();
								$(this).next('dd').fadeOut();
							}
						});
					}
				});

				var processSwiper = new Swiper('.process-container', {
					speed: 300,
					autoHeight: true,
					noSwiping: false
				});

				$('.process .navigation ol li a').on('click', function() {
					var index = $(this).attr('href').replace('#', '');
					var offset = parseInt($(this).parents('ol').find('.unfilled-line').css("left")) - 5;
					var lineWidth = (offset*2)*parseInt(index) - (parseInt(index)*18);
					$(this).addClass('current');
					$(this).parent().siblings().find('a').removeClass('current').removeClass('prev');
					$(this).parent().prevAll().find('a').addClass('prev');
					$(this).parents('ol').find('.filled-line').css('width', lineWidth);
					processSwiper.slideTo(index);
				});

				$('.process .navigation ol li:first-child a').click();

				$(window).on('resize', function() {
					$('.process .navigation').each(function() {
						var items = $(this).find('ol').children('li').length;
						$(this).find('ol').children('li').each(function() {
							$(this).css('width', (100/items)+"%");
						});
						var offset = $(this).find('ol').children('li:first-child').width() / 2 + 10;
						var lineFullWidth = $(this).find('ol').width() - (offset*2) + 20;
						var unfilledLine = "<span class='unfilled-line' style='width: "+lineFullWidth+"px; max-width: "+lineFullWidth+"px; left: "+(offset+5)+"px;'></span>";
						var filledLine = "<span class='filled-line' style='max-width: "+lineFullWidth+"px; left: "+(offset+5)+"px;''></span>";
						$(this).find('ol').append(unfilledLine).append(filledLine);
					});
					$('.process .navigation ol li a.current').click();
				});

				$('.nav-menu .menu-item-has-children').on('click', function() {
					$(this).toggleClass('submenu-open');
				});

				$(window).on('scroll', function() {
					if ($(window).scrollTop() > 0) {
						$('.preheader, header, body').addClass('fixed');
					} else {
						$('.preheader, header, body').removeClass('fixed');
					}
				});

				var origSubnavPos = $('.subnav').offset();

				$(window).on('scroll', function () {
					if ($('.subnav').length > 0) {
						if ($(window).scrollTop() > origSubnavPos.top) {
							$('.subnav').addClass('fixed');
						} else {
							$('.subnav').removeClass('fixed');
						}
					}
				});

				$('input[type="reset"], button[type="reset"]').on('click', function () {
					console.log('resetting form');
					var form = $(this).parents('form');
					form.find('select').each(function() {
						$(this).find('option').not("[value]").attr('selected','selected').siblings().removeAttr('selected');
					});
					form.find('input[type="text"]').attr("value", "");
				});

				$(window).resize();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				window.locationSelectBox = $('select.location').SumoSelect({
					selectAll: false,
					okCancelInMulti: true,
					triggerChangeCombined: true,
					forceCustomRendering: true
				});
			}
		},

		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				var currentService = $('.list .current').attr('data-item');
				$('.'+currentService).siblings().hide();

				$('.list ul li').on('mouseover', function() {
					$(this).siblings().removeClass('current');
					$(this).addClass('current');
					currentService = $(this).attr('data-item');
					$('.'+currentService).show().siblings().hide();
				});

				var mySwiper = new Swiper('.slides', {
			    speed: 1000,
			    autoHeight: true,
			    autoplay: false,
			    loop: true,
			    loopSlides: 2,
			    preventClicks: false
				});

				$('.lead a').on('mouseover', function() {
					$(this).parent().siblings().find('a').removeClass('active');
					var slideIndex = $(this).attr('data-item');
					var currentSlide = $('.slides .swiper-slide-active').attr('data-swiper-slide-index');
					if (slideIndex !== currentSlide) {
						mySwiper.slideNext(true, 1000);
					}
					$(this).addClass('active');
				});
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},

		'page_template_specialty': {
			init: function () {
				var spotlightSwiper = new Swiper('.spotlight-swiper-container', {
			    speed: 300,
			    loop: true,
			    preventClicks: false,
			    autoHeight: true
				});

				$('.controls .next, .next .next-arrow').on('click', function(e) {
					e.preventDefault();
					spotlightSwiper.slideNext();
				});

				$('.controls .prev').on('click', function(e) {
					e.preventDefault();
					spotlightSwiper.slidePrev();
				});

				$(window).on('resize', function() {
					spotlightSwiper.update();
				});
			}
		},
		'single_jobs': {
			init: function () {
				$('nav.share').stick_in_parent({
					'offset_top': 78
				});
				$('nav.share a').not('.email').on('click', function (e) {
					window.open($(this).attr('href'), 'sharewin', "width=520,height=270");
					return false;
				});
			}
		},
		'page_template_who_we_are': {
			init: function () {
				var winWidth = $(window).width();
				$('.team .item').on('click touchend', function (e) {
					if ($(e.target).parents('.item').hasClass('hover')) {
						$(this).removeClass('hover');
					} else {
						$(this).addClass('hover');
					}
				}).on('mouseenter', function(e) {
					$(this).addClass('hover');
				}).on('mouseleave', function(e) {
					$(this).removeClass('hover');
				});

				var navHighlight = $('main section:not(.lead)').waypoint({
					handler: function(direction) {
						var section = this.element.id;
						$('.subnav a[href="#'+section+'"]').addClass('current').parent().siblings().find('a.current').removeClass('current');
					},
					offset: 'bottom-in-view'
				});
				// only use custom handling if we're sticking the subnav
				if (winWidth > 768) {
					$('.subnav a').off('click');
				}

				$('.subnav a').on('click', function(e) {
					e.preventDefault();
					$(this).addClass('current').parent().siblings().find('a.current').removeClass('current');
					if (winWidth > 768) {
						var sectionId = $(this).attr('href');
						if (sectionId === '#mission') {
							// add 35 to account for negative margin
							$('body,html').animate({
								scrollTop: $(sectionId).offset().top - 233
							}, 500);
						} else {
							$('body,html').animate({
								scrollTop: $(sectionId).offset().top - 198
							},500);
						}
					}
				});
			}
		},
		'page_template_search_jobs': {
			finalize: function () {
				$(document).ready(function() {
					if (window.location.search !== "") {
						$('body,html').animate({
							scrollTop: $('section.results').offset().top - 198
						}, 500);
					}
				});
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = funcname === undefined ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.
